import { ResponseResult } from "@/store/root-types"
import axios from "./interceptors"

export interface ReportExceptionBody {
  msg: string;
}

export const reportException = (data: ReportExceptionBody) => {
  return axios.request({
    url: "api/common/notice",
    method: "GET",
    params: data
  })
}

export interface GetSystemInfoResult {
  __version: string
}

export const getSystemInfo = () => {
  return axios.request<ResponseResult<GetSystemInfoResult>>({
    baseURL: process.env.BASE_URL,
    url: "/system.json",
    method: "GET",
    params: {
      t: new Date().getTime()
    }
  })
}

export interface ListCompaniesResult {
  id: number
  com_name: string
}

export const listCompanies = () => {
  return axios.request<ResponseResult<ListCompaniesResult[]>>({
    url: "/api/admin/selector/company",
    method: "GET"
  })
}

export interface ListChannelsBody {
  company_id?: number
  depart_id?: number
  group_id?: number
}

export interface ListChannelsResult {
  id: number
  username: string
  nickname: string
  name: string
}

export const listChannels = (data?: ListChannelsBody) => {
  return axios.request<ResponseResult<ListChannelsResult[]>>({
    url: "/api/admin/selector/channel",
    method: "GET",
    params: data
  })
}

export interface ListPartnersBody {
  company_id?: string
  depart_id?: string
  group_id?: string
}

export interface ListPartnersResult {
  id: number
  username: string
  nickname: string
  name: string
}

export const listPartners = (data?: ListPartnersBody) => {
  return axios.request<ResponseResult<ListPartnersResult[]>>({
    url: "/api/admin/selector/partner",
    method: "GET",
    params: data
  })
}

export interface ListMastersBody {
  company_id?: string
  depart_id?: string
  group_id?: string
}

export interface ListMastersResult {
  id: number
  nickname: string
  douyin_uid: string
}

export const listMasters = (data?: ListMastersBody) => {
  return axios.request<ResponseResult<ListMastersResult[]>>({
    url: "/api/admin/selector/author",
    method: "GET",
    params: data
  })
}

export interface ListMasterTypesResult {
  id: number
  name: string
}

export const listMasterTypes = () => {
  return axios.request<ResponseResult<ListMasterTypesResult[]>>({
    url: "/api/admin/anchor/category",
    method: "GET"
  })
}

export interface ListExpressDetailsBody {
  post_id: string
  mobile: string
}

export interface ListExpressDetailsResult {
  number: string
  type: string
  typename: string
  logo: string
  list: {
    time: string
    status: string
  }[]
  deliverystatus: number
  issign: number
}

export const listExpressDetails = (data: ListExpressDetailsBody) => {
  return axios.request<ResponseResult<ListExpressDetailsResult>>({
    url: "/api/common/admin/express_query",
    method: "GET",
    params: data
  })
}

export interface IArchiveSeaBody {
  id: number | null
  company_id: number | null
  old_channel_id: number | null
}

/**
 * 移入公海
 */
export const archiveSea = (data: IArchiveSeaBody) => {
  return axios.request<ResponseResult>({
    url: "/api/admin/anchor/archive/sea",
    method: "POST",
    data
  })
}

export interface IReplenishAudit {
  id: number
  audited_status: number | null
  audit_failed_reason?: string | null
}

/**
 * 补样 审核
 */
export const replenishAudit = (data: IReplenishAudit) => {
  return axios.request<ResponseResult>({
    url: "/api/admin/order/order/replenish/audit",
    method: "POST",
    data
  })
}

export interface IDistributionExpertBody {
  id: number
  company_id: number
  old_channel_id?: number
  new_channel_id: number
}

/**
 * 重新分配达人 新
 */
export const DistributionExpert = (data: IDistributionExpertBody) => {
  return axios.request<ResponseResult>({
    url: "/api/admin/anchor/archive/assign",
    method: "POST",
    data
  })
}

//微信归属
export const BelongToWechat = (data: any) => {
  return axios.request({
    url: "/api/admin/anchor/archive/belong",
    method: "GET",
    params: data
  })
}
